<mat-form-field class="w-100 dense-2" [appearance]="appearance">
  <mat-label>{{ label() }}</mat-label>
  <mat-select
    [id]="id() ? 'select-' + id() : null"
    [formControl]="formControlRef()"
    [multiple]="multiple()"
    [required]="required()"
    [compareWith]="compareObjects"
    (openedChange)="ZSelectFilterInput.focus()"
  >
    <div [hidden]="!selectItems?.length">
      <input
        #ZSelectFilterInput
        id="z-select-filter-input"
        class="border-0 s-h-11 w-100 border-bottom z-select-filter-indent"
        (keydown.space)="$event.stopPropagation()"
        [formControl]="filterControl"
        [placeholder]="'filter' | transloco"
      />
    </div>
    <div
      *ngIf="multiple()"
      role="button"
      class="s-min-h-12 w-100 z-select-checkbox-container"
      (click)="toogleAll()"
    >
      <mat-checkbox
        [checked]="
          this.formControlRef()?.value?.length === this.filteredItems?.length
        "
        class="s-ms-1 z-select-checkbox"
        color="primary"
      >
        <span
          class="s-large"
          [ngClass]="{
            'c-primary-brand-color':
              this.formControlRef()?.value?.length ===
              this.filteredItems?.length
          }"
          >{{ "all" | transloco }}</span
        >
      </mat-checkbox>
    </div>

    @for (item of filteredItems; track $index) {
    <mat-option [value]="item">
      {{ item.label }}
    </mat-option>
    }
  </mat-select>
  <button
    *ngIf="
      (!multiple() && !!formControlRef().value) ||
      (multiple() && formControlRef().value?.length)
    "
    [disabled]="formControlRef().disabled"
    matSuffix
    mat-icon-button
    type="button"
    (click)="
      formControlRef().setValue(null);
      filterControl.setValue(null);
      $event.stopPropagation()
    "
  >
    <mat-icon>close</mat-icon>
  </button>
  <mat-hint align="start" *ngIf="hint">
    {{ hint() }}
  </mat-hint>
  <mat-hint align="end" class="c-status-error" *ngIf="errorMessage">
    {{ errorMessage() }}
  </mat-hint>
</mat-form-field>
